export default "__VITE_ASSET__DPjvx1G5__"